import PrivateSponsorRoute from "@components/PrivateSponsorRoute";
import { lazyWithRetry } from "@utils/appUtils";
import devConsole from "@utils/devConsole";
import { RequestType } from "src/App";
import { edit_opportunity_path, new_opportunity_path } from "./routes";

const RfpRequestForm = lazyWithRetry(() => import("../views/RfpRequestForm"));

const renderForm = (props) => {
  const searchParams = new URLSearchParams(props.location.search);
  const request_type = searchParams.get("type");
  switch (request_type) {
    case RequestType.REQUEST_FOR_PROPOSAL:
      return <RfpRequestForm />;
    default:
      devConsole.error("Unexpected request_type: %s.", request_type);
  }
};

const routes = [
  <PrivateSponsorRoute key="opportunity-new" exact path={new_opportunity_path()}>
    {renderForm}
  </PrivateSponsorRoute>,
  <PrivateSponsorRoute key="opportunity-edit" exact path={edit_opportunity_path(":slug")}>
    {renderForm}
  </PrivateSponsorRoute>,
];

export default routes;
